<script>
    import {check_time_diff_from_now_to_target} from '../datetimefunctions.js';
    import { festival_time } from '../stores.js';
    import { onMount, onDestroy } from 'svelte';
    import Countdown from './bottommessages/Countdown.svelte'
    import BuyTickets from './bottommessages/BuyTickets.svelte'
    
    let shown = "";
    //import { fade, fly } from 'svelte/transition';

    let active_number = 0;

    let views = [];

    let change_speed = 7000;
    const slide_change = () => {
        active_number += 1;
        if(active_number > (views.length - 1)){
            active_number = 0;
        }
        shown = views[active_number];
    }

    let clear;

    function is_festival_is_going_on_currently(){
        let diff_to_festival_start = check_time_diff_from_now_to_target($festival_time.start);
        let diff_to_festival_end = check_time_diff_from_now_to_target($festival_time.end);

        if(diff_to_festival_start < 0 && diff_to_festival_end > 0){
            return true;
        }
        return false;
    }

    function festival_has_ended(){
        let diff_to_festival_end = check_time_diff_from_now_to_target($festival_time.end);
        if(diff_to_festival_end < 0){
            return true;
        }
        return false;
    }

    onMount(async () => {
        //don't show countdown component during festival
        //after festival countdown-component displays "See you next year!"
        if(!is_festival_is_going_on_currently()){
            views.push("countdown");
            views = views;
        }

        if(!festival_has_ended()){
            views.push("tickets");
            views = views;
        }

        shown = views[0];

        if(views.length > 1){
            clear = setInterval(slide_change, change_speed);
        }
	});

    onDestroy(() => {
        clearInterval(clear);
    });
</script>
<div id="bottom-message-box">
    {#if shown == "countdown"}
        <!-- <div in:fly="{{ x: 200, duration: 1000 }}" out:fly="{{ x: -200, duration: 1000 }}"> -->
            <Countdown />
        <!-- </div> -->
    {/if}
    {#if shown == "tickets"}
        <!-- <div in:fly="{{ x: 200, duration: 1000 }}" out:fly="{{ x: -200, duration: 1000 }}"> -->
            <BuyTickets />
        <!-- </div> -->
    {/if}
</div>
<style>
    #bottom-message-box{
        background-color: var(--bottom-message-box-bg-color);
        width: 100%;
        height: var(--bottom-message-box-height);
        box-sizing: border-box;
        color: #fff;
        font-family: 'futura-pt', Arial;
		font-weight: 700;
		text-decoration: none;
		text-transform: none;
        font-size: 1.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        /* overflow: hidden;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 8; */
    }
    /* #bottom-message-box > div{
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        overflow: hidden;
    } */
</style>